import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
var BR_RE = /<br\s*\/?>/gi;
var TAG_RE = /<\/?[^>]+>/g;
var decodeEntities = function (value) {
    return value
        .replace(/&nbsp;/gi, '\u00a0')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>');
};
/** Рендер CMS-текста с поддержкой <br>. Без span — только Fragment + br, шрифт наследуется. */
export var renderCmsText = function (value) {
    var source = String(value || '');
    if (!source)
        return null;
    var parts = source.split(BR_RE);
    return parts.map(function (part, index) {
        var cleaned = decodeEntities(part).replace(TAG_RE, '');
        return (_jsxs(Fragment, { children: [cleaned, index < parts.length - 1 ? _jsx("br", {}) : null] }, index));
    });
};
